import {combineReducers} from 'redux';
import {persistReducer} from 'redux-persist';
import {connectRouter} from 'connected-react-router';
import storage from 'redux-persist/es/storage';
import store, {history} from '../boot/configureStore';

import FeedbackReducer from '../containers/FeedbackContainer/reducer';
import forgotReducer from '../containers/FrgtPswdContainer/reducer';
import CountryReducer from '../containers/CountryContainer/reducer';
import DistributorReducer from '../containers/DistributorProfileContainer/reducer';
import CurrencyReducer from '../containers/CurrencyContainer/reducer';
import StateReducer from '../containers/StateContainer/reducer';
import DistrictReducer from '../containers/DistrictContainer/reducer';
import CountryCrncyReducer from '../containers/CountryCrncyContainer/reducer';
import PaymentModeReducer from '../containers/PaymentModeContainer/reducer';
import UnitReducer from '../containers/UnitContainer/reducer';
import BrandReducer from '../containers/BrandContainer/reducer';
import LicenseeReducer from '../containers/LicenseeContainer/reducer';
import AppversionReducer from '../containers/AppversionContainer/reducer';
import DashboardReducer from '../containers/DefaultLayout/reducer';
import PatientsReducer from '../containers/PatientsProfileContainer/reducer';
import PatientPaymentReducer from '../containers/PatientPaymentContainer/reducer';
import PatientInvoiceReducer from '../containers/PatientInvoiceContainer/reducer';
import ChemistReducer from '../containers/ChemistProfileContainer/reducer';
import ChemistOrderReducer from '../containers/ChemistOrderContainer/reducer';
import ChemistPaymentReducer from '../containers/ChemistPaymentContainer/reducer';
import ChemistInvoiceReducer from '../containers/ChemistInvoiceContainer/reducer';
import SupportReducer from '../containers/SupportContainer/reducer';
import SupportUsersReducer from '../containers/SupportUsersContainer/reducer';
import PatientsOrderReducer from '../containers/PatientsOrderContainer/reducer';
import ItemCategoryReducer from '../containers/ItemCategoryContainer/reducer';
import SupportTypeReducer from '../containers/SupportTypeContainer/reducer';
import ItemMasterReducer from '../containers/ItemMasterContainer/reducer';
import ProductReturnsReducer from '../containers/ProductReturnsContainer/reducer';
import ExpiryReturnsReducer from "../containers/ExpiryReturnsContainer/reducer";
import CreditNotesReducer from '../containers/CreditNotesContainer/reducer';
import AuditTraceReducer from '../containers/AuditTraceContainer/reducer';
import DeliveryStatusReducer from '../containers/DeliveryStatusContainer/reducer';
import TermsandConditionReducer from '../containers/TermsandConditionContainer/reducer';
import HelplineReducer from '../containers/HelplineContainer/reducer';
import BankReducer from '../containers/BankContainer/reducer';
import CpvalueReducer from '../containers/CpvalueContainer/reducer';
const createRootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    FeedbackReducer,
    PatientsReducer,
    PatientPaymentReducer,
    PatientInvoiceReducer,
    forgotReducer,
    CountryReducer,
    DistributorReducer,
    CurrencyReducer,
    DistrictReducer,
    StateReducer,
    CountryCrncyReducer,
    PaymentModeReducer,
    DeliveryStatusReducer,
    UnitReducer,
    BrandReducer,
    LicenseeReducer,
    AppversionReducer,
    DashboardReducer,
    ChemistReducer,
    ChemistOrderReducer,
    ChemistPaymentReducer,
    ChemistInvoiceReducer,
    SupportReducer,
    SupportUsersReducer,
    PatientsOrderReducer,
    ItemCategoryReducer,
    SupportTypeReducer,
    ItemMasterReducer,
    ProductReturnsReducer,
    ExpiryReturnsReducer,
    CreditNotesReducer,
    AuditTraceReducer,
    TermsandConditionReducer,
    HelplineReducer,
    BankReducer,
    CpvalueReducer,
  });

export default createRootReducer;
